import { render, staticRenderFns } from "./DraggableListsMobileLayers.vue?vue&type=template&id=4210e4b1&scoped=true&"
import script from "./DraggableListsMobileLayers.vue?vue&type=script&lang=js&"
export * from "./DraggableListsMobileLayers.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsMobileLayers.vue?vue&type=style&index=0&id=4210e4b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4210e4b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTooltip})
